import { captureException } from "@sentry/browser";

import { generateApolloClientInstance, isAuthTokenRejectedError } from "settings/apollo";
import { getIdToken, logout } from "settings/auth0";

import type { TLoaderWithQueryFn } from "../../types";

/**
 *
 * @param param0 Loader Args from React Router, check it for more information -> https://reactrouter.com/en/main/start/overview#data-loading
 * @param query GraphQL document query
 * @param entityName Entity name that is being accessed in the route
 * @param breadcrumbTextPath Path string or function with path in param to get the text (relative to query result schema) that will be displayed in breadcrumb
 * @returns label and data, where label is the dynamic breadcrumb text and data is the result query
 */

export const loaderWithQueryByIdParams: TLoaderWithQueryFn = async (
  { params },
  query,
  entityName,
  breadcrumbTextPath,
) => {
  const apolloClient = generateApolloClientInstance(getIdToken, logout);

  try {
    const { data: resultData } = await apolloClient.query({ query, variables: { id: Number(params.id) } });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data: Record<string, any> = resultData?.[entityName];

    let label = "";

    if (typeof breadcrumbTextPath === "string" && breadcrumbTextPath) {
      label = data?.[breadcrumbTextPath];
    }

    if (typeof breadcrumbTextPath !== "string" && breadcrumbTextPath) {
      label = breadcrumbTextPath(data);
    }

    return { label, [entityName]: data };
  } catch (error) {
    captureException(error);

    if (isAuthTokenRejectedError(error)) {
      await logout();
    }

    return { label: "", [entityName]: null };
  }
};
